<template>
  <div id="app">
    <v-header v-if="!$route.meta.noHeader && isPC" />
    <p-header v-if="!$route.meta.noHeader && !isPC" />
    <keep-alive>
        <!-- 可以被缓存的视图组件 -->
        <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/> <!-- 不可以被缓存的视图组件 -->
    <v-footer v-if="!$route.meta.noHeader && isPC" />
    <p-footer v-if="!$route.meta.noHeader && !isPC" />
  </div>
</template>
<script>
import vHeader from '@/components/header'
import vFooter from '@/components/footer'
import pHeader from '@/components/phoneHeader'
import pFooter from '@/components/phoneFooter'
import { setExposure } from '@/util/utils'

export default {
    data () {
    return {
      isPC: this.GLOBAL.isPC(),
      appKey:process.env.APP_KEY,
    }
  },
  beforeCreate() {
    // let backUrl = location.href.replace(/\#\//g, '');//替换掉`#/`
    // console.log(backUrl)
    // if(backUrl.indexOf("from=miniAPP")>0){
    //   sessionStorage.setItem("sourceName","miniAPP")
    // }
  },
  created() {
    (function(w, d, s, q, i) {
        w[q] = w[q] || [];
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s);
        j.async = true;
        j.id = "beacon-aplus";
        j.src = "https://d.alicdn.com/alilog/mlog/aplus/" + i + ".js";
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "aplus_queue", "203467608");

      //集成应用的appKey
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["appKey", this.appKey]
      });
      /************************以下内容为可选配置内容****************************/
      //sdk提供手动pv发送机制，启用手动pv(即关闭自动pv)，需设置aplus-waiting=MAN;
      //注意：由于单页面路由改变时不会刷新页面，无法自动发送pv，所以对于单页应用，强烈建议您关闭自动PV, 手动控制PV事件
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["aplus-waiting", "MAN"]
      });
      //是否开启调试模式
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["DEBUG", true]
      });
      //是否指定用作计算umid的id类型，默认为cnaid，目前支持:
      //1. 微信和QQ: openid; 字节和百度 anonymousid; 支付宝 alipay_id
      //2. 微信、QQ、字节、百度平台的 unionid
      //3. 业务方自己生成的随机id uuid
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["aplus-idtype", "cnaid"] //取值参考见附表1
      });
      //设置userid
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["_user_id", "939101077@qq.com"] //值为业务自定义的登录账号ID
      });
      //自动曝光 页面浏览
      setExposure()
  },
  watch:{
    $route(val) {
      //console.log(val,'路由')
      if(val.meta && val.meta.pageName) {
        const {aplus_queue} = window;
        aplus_queue.push({
          action: 'aplus.sendPV',
          arguments: [{
                is_auto: false
          }, {
                page_name: val.meta.pageName,
                page_url:location.href
        }]
        });
      }
    }
  },
  mounted() {
  },
  components: {
    vHeader,
    vFooter,
    pHeader,
    pFooter,
  }
}
</script>

<style lang="scss">
#app {//全局样式
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 72px;
}
.page-container {
  margin-top: 120px;
  min-width: 1000px;
  padding: 0 50px;
  overflow: hidden;
  
  .left-content {
    float: left;
    margin-top: -14px;
    margin-left: 40px;
    line-height: 50px;
    & > li {
      position: relative;
      cursor: pointer;
      list-style-type: none;
      &:before {
        content: '';
        position: absolute;
        width: 3px;
        height: 12px;
        top: 19px;
        left: -12px;
        background-color: #FF9066;
      }
      ul {
        li {
          color: #666666;
          cursor: pointer;
          list-style-type: none;
        }
      }
    }
  }
  .right-content {
    margin-left: 24%;
    width: 76%;
  }
}
.main-content {
  padding: 0 16%;
}

// body,html,ul,li,div,p {
//   &::-webkit-scrollbar { 
//     width: 0 !important;
//     display: none !important;
//   }
// }

// body::-webkit-scrollbar { display: none !important; }
</style>



// WEBPACK FOOTER //
// src/App.vue